export function getCookie(name) {
  const output = {}
  document.cookie.split(';').forEach(cookie => {
    const rows = cookie.split('=').map(value => value.trim())
    if (rows && rows[0]) {
      output[rows[0]] = rows[1]
    }
  })
  if (name) {
    return output[name] || null
  } else {
    return output
  }
}

export function setCookie(name, value, expires, domain) {
  // let date = new Date()
  // console.log(date.toUTCString())
  // let expires = ''
  // if (days) {
  //   date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
  //   expires = '; expires=' + date.toUTCString()
  // }
  let domainStr = ''
  if (!expires) {
    // console.log('no expires')
    const date = new Date()
    const utc = date.getTime() + (date.getTimezoneOffset() * 60000)
    const twDate = new Date(utc + (3600000 * 8))
    expires = new Date(`${twDate.getFullYear()}/${twDate.getMonth() + 1}/${twDate.getDate()} 23:59:59`)
  }
  if (domain) {
    domainStr = 'domain=' + domain + ';'
  }
  document.cookie = name + '=' + (value || '') + '; expires=' + expires + '; ' + domainStr + ' path=/'
}

export function getURLParamters(param, url) {
  if (!url) url = window.location.href
  const urlAry = url.split('?')
  const output = {}
  if (urlAry[1]) {
    urlAry[1].split('&').map(apart => {
      const tmpAry = apart.split('=') // tmpAry[0] => key, tmpAry[1] => value
      output[tmpAry[0]] = tmpAry[1]
    })
    if (param && output[param]) {
      return output[param]
    }
  }
  return output
}

export function getParameter(param, url) {
  if (!url) url = window.location.href
  const urlAry = url.split('?')
  if (urlAry[1]) {
    let paramValue = ''
    urlAry[1].split('&').map(apart => {
      const tmpAry = apart.split('=') // tmpAry[0] => key, tmpAry[1] => value
      if (tmpAry[0]) {
        paramValue = tmpAry[1]
      }
    })
    return paramValue
  }
  return null
}
export function getLocalStorage(param) {
  try {
    return window.localStorage.getItem(param)
  } catch (e) {
    return null
  }
}

export function randomGUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
}
